import React, { PropTypes } from 'react';
import cn from 'classnames';
import moment from 'moment';
import _ from 'lodash';
import { Row, Col, Icon, Alert, Button } from 'antd';
import { formatNumber } from 'utils/formatting';
import classes from '../styles/student/StudentInfo.module.scss';

import { Link } from 'react-router';

const formatVerifiedStatus = (status) => {
  let verifiedStatus;
  switch (status) {
    case 'verified':
      verifiedStatus = 'Yes';
      break;
    case 'pending':
      verifiedStatus = 'Pending';
      break;
    case 'submitted':
      verifiedStatus = 'Pending';
      break;
    default:
      verifiedStatus = 'No';
      break;
  }
  return verifiedStatus;
};

const StudentHeader = ({ user, Tabs, onOpenBanModal, onOpenAddPointModal }) => {
  if (!user) return <div />;
  const registerDate = moment(user.createdAt).format('DD/MM/YYYY');
  return (
    <div className={cn('content-header', classes.headerContainer)}>
      {user.isBan && <Alert message="Banned" type="error" description={' '} />}
      <Row>
        <Col xs={24}>
          <div className="pull-right">
            <Button type="danger" onClick={onOpenBanModal}>
              {user.isBan ? 'Unban' : 'Ban'}
            </Button>
            &nbsp;&nbsp;&nbsp;
            <Button onClick={onOpenAddPointModal}>
              <Icon type="plus" /> Add Point
            </Button>
          </div>
          <div className="header-title">
            <span className="bold">Student: </span>
            {`${user.name.first} ${user.name.last ? user.name.last : ''} `}
            {user.verified && <Icon type="check-circle" className="text-primary" />}
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={3}>
          <div className={classes.imageContainer}>
            <img className={cn(classes.profileImage)} src={`${user.displayImage}?${new Date().getTime()}`} />
          </div>
        </Col>
        <Col xs={8}>
          <div>
            <span className="bold">Display Name:</span> {user.displayName}
          </div>
          <div>
            <span className="bold">Student No.:</span> {user.code}
          </div>
          <div>
            <span className="bold">Register Date: </span>
            {registerDate}
          </div>
        </Col>
        <Col xs={8}>
          <div>
            <span className="bold">T-Points Balance: </span>
            {formatNumber(user.points, '0,0')} points
          </div>
          <div>
            <span className="bold">Already Learned: </span>
            {user.studiedCount}
          </div>
        </Col>
        <Col xs={5}>
          <div>
            <span className="bold">Teacher?: </span>
            {user.isTeacher && <Link to={`/teacher/${user.teacher._id}`}>Yes</Link>}
            {!user.isTeacher && 'No'}
          </div>
          <div>
            <span className="bold">Verification: </span> {formatVerifiedStatus(_.get(user, 'teacher.verifyStatus'))}
          </div>
          <div>
            <span className="bold">Email Verification: </span> {user.verifiedEmail ? 'Yes' : 'No'}
          </div>
        </Col>
      </Row>
      {user.remark && (
        <Row>
          <Col xs={24}>
            <span className="bold"> Remark: </span>
            <span className="remark-text">{user.remark}</span>
          </Col>
        </Row>
      )}
      {Tabs}
    </div>
  );
};

export default StudentHeader;
